import { render, staticRenderFns } from "./studentExamWinding.vue?vue&type=template&id=3c74bbd9&scoped=true"
import script from "./studentExamWinding.vue?vue&type=script&lang=js"
export * from "./studentExamWinding.vue?vue&type=script&lang=js"
import style0 from "./studentExamWinding.vue?vue&type=style&index=0&id=3c74bbd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c74bbd9",
  null
  
)

export default component.exports